import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
import { API_ENDPOINTS } from '../../../../utils/config';

const REQUEST_TIMEOUT_MS = 20000;

const EmployeeModal = ({ isOpen, onClose, employee, onSave, mode = 'add' }) => {
  const [formData, setFormData] = useState({
    basic_information: {
      title: '',
      full_name: '',
      employee_id: '',
      employee_status: 'active',
      "father's_name": '',
      office_email: '',
      personal_email: '',
      date_of_birth: '',
      office_mobile_number: '',
      personal_mobile_number: '',
      emergency_contact: ''
    },
    employment_information: {
      designation: '',
      department: '',
      reporting_to: '',
      branch: '',
      employment_type: '',
      date_of_joining: '',
      date_of_exit: '',
      check_in_time: '',
      check_out_time: ''
    },
    personal_information: {
      gender: '',
      marital_status: '',
      blood_group: '',
      relegion: '',
      aadhar_number: '',
      pan: '',
      uan: '',
      ESI: '',
      basic_salary: '',
      gross_salary: ''
    },
    present_address: {
      address_line1: '',
      address_line_2: '',
      city: '',
      postal_code: '',
      state: '',
      country: ''
    },
    permanent_address: {
      address_line1: '',
      address_line_2: '',
      city: '',
      postal_code: '',
      state: '',
      country: ''
    },
    banking_details: {
      account_number: '',
      account_holder_name: '',
      bank_name: '',
      ifsc_code: '',
      account_type: '',
      branch_name: ''
    }
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [activeSection, setActiveSection] = useState('basic');

  useEffect(() => {
    if (isOpen) {
      if (employee && mode === 'edit') {
        const empData = employee?.employee_data || {};
        setFormData({
          basic_information: {
            title: empData?.basic_information?.title || '',
            full_name: empData?.basic_information?.full_name || '',
            employee_id: empData?.basic_information?.employee_id || '',
            employee_status: empData?.basic_information?.employee_status || 'active',
            "father's_name": empData?.basic_information?.["father's_name"] || '',
            office_email: empData?.basic_information?.office_email || '',
            personal_email: empData?.basic_information?.personal_email || '',
            date_of_birth: empData?.basic_information?.date_of_birth || '',
            office_mobile_number: empData?.basic_information?.office_mobile_number || '',
            personal_mobile_number: empData?.basic_information?.personal_mobile_number || '',
            emergency_contact: empData?.basic_information?.emergency_contact || ''
          },
          employment_information: {
            designation: empData?.employment_information?.designation || '',
            department: empData?.employment_information?.department || '',
            reporting_to: empData?.employment_information?.reporting_to || '',
            branch: empData?.employment_information?.branch || '',
            employment_type: empData?.employment_information?.employment_type || '',
            date_of_joining: empData?.employment_information?.date_of_joining || '',
            date_of_exit: empData?.employment_information?.date_of_exit || '',
            check_in_time: empData?.employment_information?.check_in_time || '',
            check_out_time: empData?.employment_information?.check_out_time || ''
          },
          personal_information: {
            gender: empData?.personal_information?.gender || '',
            marital_status: empData?.personal_information?.marital_status || '',
            blood_group: empData?.personal_information?.blood_group || '',
            relegion: empData?.personal_information?.relegion || '',
            aadhar_number: empData?.personal_information?.aadhar_number || '',
            pan: empData?.personal_information?.pan || '',
            uan: empData?.personal_information?.uan || '',
            ESI: empData?.personal_information?.ESI || '',
            basic_salary: empData?.personal_information?.basic_salary || '',
            gross_salary: empData?.personal_information?.gross_salary || ''
          },
          present_address: {
            address_line1: empData?.present_address?.address_line1 || '',
            address_line_2: empData?.present_address?.address_line_2 || '',
            city: empData?.present_address?.city || '',
            postal_code: empData?.present_address?.postal_code || '',
            state: empData?.present_address?.state || '',
            country: empData?.present_address?.country || ''
          },
          permanent_address: {
            address_line1: empData?.permanent_address?.address_line1 || '',
            address_line_2: empData?.permanent_address?.address_line_2 || '',
            city: empData?.permanent_address?.city || '',
            postal_code: empData?.permanent_address?.postal_code || '',
            state: empData?.permanent_address?.state || '',
            country: empData?.permanent_address?.country || ''
          },
          banking_details: {
            account_number: empData?.banking_details?.account_number || '',
            account_holder_name: empData?.banking_details?.account_holder_name || '',
            bank_name: empData?.banking_details?.bank_name || '',
            ifsc_code: empData?.banking_details?.ifsc_code || '',
            account_type: empData?.banking_details?.account_type || '',
            branch_name: empData?.banking_details?.branch_name || ''
          }
        });
      } else {
        // Reset form for add mode
        setFormData({
          basic_information: {
            title: '',
            full_name: '',
            employee_id: '',
            employee_status: 'active',
            "father's_name": '',
            office_email: '',
            personal_email: '',
            date_of_birth: '',
            office_mobile_number: '',
            personal_mobile_number: '',
            emergency_contact: ''
          },
          employment_information: {
            designation: '',
            department: '',
            reporting_to: '',
            branch: '',
            employment_type: '',
            date_of_joining: '',
            date_of_exit: '',
            check_in_time: '',
            check_out_time: ''
          },
          personal_information: {
            gender: '',
            marital_status: '',
            blood_group: '',
            relegion: '',
            aadhar_number: '',
            pan: '',
            uan: '',
            ESI: '',
            basic_salary: '',
            gross_salary: ''
          },
          present_address: {
            address_line1: '',
            address_line_2: '',
            city: '',
            postal_code: '',
            state: '',
            country: ''
          },
          permanent_address: {
            address_line1: '',
            address_line_2: '',
            city: '',
            postal_code: '',
            state: '',
            country: ''
          },
          banking_details: {
            account_number: '',
            account_holder_name: '',
            bank_name: '',
            ifsc_code: '',
            account_type: '',
            branch_name: ''
          }
        });
      }
      setErrors({});
      setSuccessMessage('');
      setErrorMessage('');
      setActiveSection('basic');
    }
  }, [isOpen, employee, mode]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const str = String(dateString).trim();
    // Extract date part from ISO strings (e.g. "2024-01-15T00:00:00Z")
    const datePart = str.split('T')[0];
    const parts = datePart.split('-');
    if (parts.length === 3) {
      // Already YYYY-MM-DD (year is first, 4 digits)
      if (parts[0].length === 4 && parseInt(parts[0], 10) > 1900) {
        return datePart;
      }
      // DD-MM-YYYY from API -> convert to YYYY-MM-DD for input
      if (parts[2]?.length === 4) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }
    return str;
  };

  const formatDateForAPI = (dateString) => {
    if (!dateString) return '';
    // Convert YYYY-MM-DD to DD-MM-YYYY for API
    const parts = dateString.split('-');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  };

  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
    
    // Clear error for this field
    const errorKey = `${section}.${field}`;
    if (errors[errorKey]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[errorKey];
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Basic Information validation
    if (!formData.basic_information.full_name) {
      newErrors['basic_information.full_name'] = 'Full name is required';
    }
    if (!formData.basic_information.employee_id) {
      newErrors['basic_information.employee_id'] = 'Employee ID is required';
    }
    if (!formData.basic_information.office_email) {
      newErrors['basic_information.office_email'] = 'Office email is required';
    }
    
    // Employment Information validation
    if (!formData.employment_information.designation) {
      newErrors['employment_information.designation'] = 'Designation is required';
    }
    if (!formData.employment_information.department) {
      newErrors['employment_information.department'] = 'Department is required';
    }
    if (!formData.employment_information.date_of_joining) {
      newErrors['employment_information.date_of_joining'] = 'Date of joining is required';
    }
    
    // Personal Information validation
    if (!formData.personal_information.basic_salary) {
      newErrors['personal_information.basic_salary'] = 'Basic salary is required';
    }
    if (!formData.personal_information.gross_salary) {
      newErrors['personal_information.gross_salary'] = 'Gross salary is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      setErrorMessage('Please fill in all required fields');
      return;
    }
    
    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');
    
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      // Format dates for API
      const payload = {
        employee_data: {
          basic_information: {
            ...formData.basic_information,
            date_of_birth: formatDateForAPI(formData.basic_information.date_of_birth)
          },
          employment_information: {
            ...formData.employment_information,
            date_of_joining: formatDateForAPI(formData.employment_information.date_of_joining),
            date_of_exit: formData.employment_information.date_of_exit ? formatDateForAPI(formData.employment_information.date_of_exit) : ''
          },
          personal_information: {
            ...formData.personal_information,
            basic_salary: Number(formData.personal_information.basic_salary) || 0,
            gross_salary: Number(formData.personal_information.gross_salary) || 0
          },
          present_address: formData.present_address,
          permanent_address: formData.permanent_address,
          banking_details: formData.banking_details
        }
      };

      let response;
      if (mode === 'edit' && employee?.id) {
        response = await axios.put(
          API_ENDPOINTS.EMPLOYEES_UPDATE(employee.id),
          payload,
          { headers, timeout: REQUEST_TIMEOUT_MS }
        );
      } else {
        response = await axios.post(
          API_ENDPOINTS.EMPLOYEES_CREATE,
          payload,
          { headers, timeout: REQUEST_TIMEOUT_MS }
        );
      }

      if (response.data) {
        setSuccessMessage(mode === 'edit' ? 'Employee updated successfully' : 'Employee created successfully');
        setTimeout(() => {
          onSave();
          onClose();
        }, 1000);
      }
    } catch (error) {
      const apiError = error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Failed to save employee';
      setErrorMessage(apiError);
    } finally {
      setIsSubmitting(false);
    }
  };

  const copyPresentToPermanent = () => {
    setFormData(prev => ({
      ...prev,
      permanent_address: { ...prev.present_address }
    }));
  };

  if (!isOpen) return null;

  const getSectionErrors = (sectionPrefix) => {
    return Object.keys(errors).filter(key => key.startsWith(sectionPrefix)).length;
  };

  const sections = [
    { id: 'basic', label: 'Basic Information', prefix: 'basic_information' },
    { id: 'employment', label: 'Employment Information', prefix: 'employment_information' },
    { id: 'personal', label: 'Personal Information', prefix: 'personal_information' },
    { id: 'present', label: 'Present Address', prefix: 'present_address' },
    { id: 'permanent', label: 'Permanent Address', prefix: 'permanent_address' },
    { id: 'banking', label: 'Banking Details', prefix: 'banking_details' }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg border border-gray-200 w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-xl font-semibold text-gray-900">
            {mode === 'edit' ? 'Edit Employee' : 'Add New Employee'}
          </h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
          >
            <X size={20} />
          </Button>
        </div>

        <div className="border-b border-gray-200 px-6 flex-shrink-0">
          <nav className="flex -mb-px space-x-4 overflow-x-auto">
            {sections.map((section) => {
              const hasErrors = getSectionErrors(section.prefix) > 0;
              return (
                <button
                  key={section.id}
                  type="button"
                  onClick={() => setActiveSection(section.id)}
                  className={`py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap relative ${
                    activeSection === section.id
                      ? 'border-blue-600 text-blue-600'
                      : hasErrors
                      ? 'border-transparent text-red-500 hover:text-red-700 hover:border-red-300'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {section.label}
                  {hasErrors && (
                    <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                  )}
                </button>
              );
            })}
          </nav>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
          <div className="overflow-y-auto flex-1 p-6 space-y-6">
            {successMessage && (
              <div className="p-3 rounded-md border border-green-300 bg-green-50 text-green-700">
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5" />
                  <p className="text-sm font-medium">{successMessage}</p>
                </div>
              </div>
            )}
            {errorMessage && (
              <div className="p-3 rounded-md border border-red-300 bg-red-50 text-red-700">
                <div className="flex items-center gap-2">
                  <AlertCircle className="w-5 h-5" />
                  <p className="text-sm">{errorMessage}</p>
                </div>
              </div>
            )}

            {activeSection === 'basic' && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Basic Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Title"
                    type="text"
                    placeholder="Mr./Ms./Mrs."
                    value={formData?.basic_information?.title}
                    onChange={(e) => handleInputChange('basic_information', 'title', e?.target?.value)}
                  />
                  
                  <Input
                    label="Full Name"
                    type="text"
                    placeholder="Enter full name"
                    value={formData?.basic_information?.full_name}
                    onChange={(e) => handleInputChange('basic_information', 'full_name', e?.target?.value)}
                    error={errors?.['basic_information.full_name']}
                    required
                  />
                  
                  <Input
                    label="Employee ID"
                    type="text"
                    placeholder="e.g., EMP001"
                    value={formData?.basic_information?.employee_id}
                    onChange={(e) => handleInputChange('basic_information', 'employee_id', e?.target?.value)}
                    error={errors?.['basic_information.employee_id']}
                    required
                  />
                  
                  <div>
                    <label className="block text-sm font-medium text-foreground mb-2">
                      Employee Status
                    </label>
                    <select
                      value={formData?.basic_information?.employee_status}
                      onChange={(e) => handleInputChange('basic_information', 'employee_status', e?.target?.value)}
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  
                  <Input
                    label="Father's Name"
                    type="text"
                    placeholder="Enter father's name"
                    value={formData?.basic_information?.["father's_name"]}
                    onChange={(e) => handleInputChange('basic_information', "father's_name", e?.target?.value)}
                  />
                  
                  <Input
                    label="Office Email"
                    type="email"
                    placeholder="office@example.com"
                    value={formData?.basic_information?.office_email}
                    onChange={(e) => handleInputChange('basic_information', 'office_email', e?.target?.value)}
                    error={errors?.['basic_information.office_email']}
                    required
                  />
                  
                  <Input
                    label="Personal Email"
                    type="email"
                    placeholder="personal@example.com"
                    value={formData?.basic_information?.personal_email}
                    onChange={(e) => handleInputChange('basic_information', 'personal_email', e?.target?.value)}
                  />
                  
                  <Input
                    label="Date of Birth"
                    type="date"
                    value={formatDateForInput(formData?.basic_information?.date_of_birth)}
                    onChange={(e) => handleInputChange('basic_information', 'date_of_birth', e?.target?.value)}
                  />
                  
                  <Input
                    label="Office Mobile Number"
                    type="tel"
                    placeholder="+91-9876543210"
                    value={formData?.basic_information?.office_mobile_number}
                    onChange={(e) => handleInputChange('basic_information', 'office_mobile_number', e?.target?.value)}
                  />
                  
                  <Input
                    label="Personal Mobile Number"
                    type="tel"
                    placeholder="+91-9876543432"
                    value={formData?.basic_information?.personal_mobile_number}
                    onChange={(e) => handleInputChange('basic_information', 'personal_mobile_number', e?.target?.value)}
                  />
                  
                  <Input
                    label="Emergency Contact"
                    type="tel"
                    placeholder="9848022338"
                    value={formData?.basic_information?.emergency_contact}
                    onChange={(e) => handleInputChange('basic_information', 'emergency_contact', e?.target?.value)}
                  />
                </div>
              </div>
            )}

            {activeSection === 'employment' && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Employment Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Designation"
                    type="text"
                    placeholder="e.g., Developer"
                    value={formData?.employment_information?.designation}
                    onChange={(e) => handleInputChange('employment_information', 'designation', e?.target?.value)}
                    error={errors?.['employment_information.designation']}
                    required
                  />
                  
                  <Input
                    label="Department"
                    type="text"
                    placeholder="e.g., Tech"
                    value={formData?.employment_information?.department}
                    onChange={(e) => handleInputChange('employment_information', 'department', e?.target?.value)}
                    error={errors?.['employment_information.department']}
                    required
                  />
                  
                  <Input
                    label="Reporting To"
                    type="text"
                    placeholder="e.g., Manager"
                    value={formData?.employment_information?.reporting_to}
                    onChange={(e) => handleInputChange('employment_information', 'reporting_to', e?.target?.value)}
                  />
                  
                  <Input
                    label="Branch"
                    type="text"
                    placeholder="e.g., Bengaluru"
                    value={formData?.employment_information?.branch}
                    onChange={(e) => handleInputChange('employment_information', 'branch', e?.target?.value)}
                  />
                  
                  <Input
                    label="Employment Type"
                    type="text"
                    placeholder="e.g., Full Time"
                    value={formData?.employment_information?.employment_type}
                    onChange={(e) => handleInputChange('employment_information', 'employment_type', e?.target?.value)}
                  />
                  
                  <Input
                    label="Date of Joining"
                    type="date"
                    value={formatDateForInput(formData?.employment_information?.date_of_joining)}
                    onChange={(e) => handleInputChange('employment_information', 'date_of_joining', e?.target?.value)}
                    error={errors?.['employment_information.date_of_joining']}
                    required
                  />
                  
                  <Input
                    label="Date of Exit"
                    type="date"
                    value={formatDateForInput(formData?.employment_information?.date_of_exit)}
                    onChange={(e) => handleInputChange('employment_information', 'date_of_exit', e?.target?.value)}
                  />
                  
                  <Input
                    label="Check In Time"
                    type="time"
                    value={formData?.employment_information?.check_in_time}
                    onChange={(e) => handleInputChange('employment_information', 'check_in_time', e?.target?.value)}
                  />
                  
                  <Input
                    label="Check Out Time"
                    type="time"
                    value={formData?.employment_information?.check_out_time}
                    onChange={(e) => handleInputChange('employment_information', 'check_out_time', e?.target?.value)}
                  />
                </div>
              </div>
            )}

            {activeSection === 'personal' && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Personal Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground mb-2">
                      Gender
                    </label>
                    <select
                      value={formData?.personal_information?.gender}
                      onChange={(e) => handleInputChange('personal_information', 'gender', e?.target?.value)}
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-foreground mb-2">
                      Marital Status
                    </label>
                    <select
                      value={formData?.personal_information?.marital_status}
                      onChange={(e) => handleInputChange('personal_information', 'marital_status', e?.target?.value)}
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                    >
                      <option value="">Select Status</option>
                      <option value="single">Single</option>
                      <option value="married">Married</option>
                      <option value="divorced">Divorced</option>
                      <option value="widowed">Widowed</option>
                    </select>
                  </div>
                  
                  <Input
                    label="Blood Group"
                    type="text"
                    placeholder="e.g., B+ve"
                    value={formData?.personal_information?.blood_group}
                    onChange={(e) => handleInputChange('personal_information', 'blood_group', e?.target?.value)}
                  />
                  
                  <Input
                    label="Religion"
                    type="text"
                    placeholder="e.g., Hindu"
                    value={formData?.personal_information?.relegion}
                    onChange={(e) => handleInputChange('personal_information', 'relegion', e?.target?.value)}
                  />
                  
                  <Input
                    label="Aadhar Number"
                    type="text"
                    placeholder="122016122016"
                    value={formData?.personal_information?.aadhar_number}
                    onChange={(e) => handleInputChange('personal_information', 'aadhar_number', e?.target?.value)}
                  />
                  
                  <Input
                    label="PAN"
                    type="text"
                    placeholder="AQOPTQ698G"
                    value={formData?.personal_information?.pan}
                    onChange={(e) => handleInputChange('personal_information', 'pan', e?.target?.value)}
                  />
                  
                  <Input
                    label="UAN"
                    type="text"
                    placeholder="aaaaaaaaa"
                    value={formData?.personal_information?.uan}
                    onChange={(e) => handleInputChange('personal_information', 'uan', e?.target?.value)}
                  />
                  
                  <Input
                    label="ESI"
                    type="text"
                    placeholder="ESI number"
                    value={formData?.personal_information?.ESI}
                    onChange={(e) => handleInputChange('personal_information', 'ESI', e?.target?.value)}
                  />
                  
                  <Input
                    label="Basic Salary"
                    type="number"
                    placeholder="25000"
                    value={formData?.personal_information?.basic_salary}
                    onChange={(e) => handleInputChange('personal_information', 'basic_salary', e?.target?.value)}
                    error={errors?.['personal_information.basic_salary']}
                    required
                  />
                  
                  <Input
                    label="Gross Salary"
                    type="number"
                    placeholder="35000"
                    value={formData?.personal_information?.gross_salary}
                    onChange={(e) => handleInputChange('personal_information', 'gross_salary', e?.target?.value)}
                    error={errors?.['personal_information.gross_salary']}
                    required
                  />
                </div>
              </div>
            )}

            {activeSection === 'present' && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Present Address</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Address Line 1"
                    type="text"
                    placeholder="#5,near swamy temple,"
                    value={formData?.present_address?.address_line1}
                    onChange={(e) => handleInputChange('present_address', 'address_line1', e?.target?.value)}
                  />
                  
                  <Input
                    label="Address Line 2"
                    type="text"
                    placeholder="NGO colony,Shivamoga"
                    value={formData?.present_address?.address_line_2}
                    onChange={(e) => handleInputChange('present_address', 'address_line_2', e?.target?.value)}
                  />
                  
                  <Input
                    label="City"
                    type="text"
                    placeholder="Shivamoga"
                    value={formData?.present_address?.city}
                    onChange={(e) => handleInputChange('present_address', 'city', e?.target?.value)}
                  />
                  
                  <Input
                    label="Postal Code"
                    type="text"
                    placeholder="584584"
                    value={formData?.present_address?.postal_code}
                    onChange={(e) => handleInputChange('present_address', 'postal_code', e?.target?.value)}
                  />
                  
                  <Input
                    label="State"
                    type="text"
                    placeholder="Karnataka"
                    value={formData?.present_address?.state}
                    onChange={(e) => handleInputChange('present_address', 'state', e?.target?.value)}
                  />
                  
                  <Input
                    label="Country"
                    type="text"
                    placeholder="India"
                    value={formData?.present_address?.country}
                    onChange={(e) => handleInputChange('present_address', 'country', e?.target?.value)}
                  />
                </div>
              </div>
            )}

            {activeSection === 'permanent' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-medium text-gray-900">Permanent Address</h3>
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={copyPresentToPermanent}
                  >
                    Copy from Present Address
                  </Button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Address Line 1"
                    type="text"
                    placeholder="#5,near swamy temple,"
                    value={formData?.permanent_address?.address_line1}
                    onChange={(e) => handleInputChange('permanent_address', 'address_line1', e?.target?.value)}
                  />
                  
                  <Input
                    label="Address Line 2"
                    type="text"
                    placeholder="NGO colony,Shivamoga"
                    value={formData?.permanent_address?.address_line_2}
                    onChange={(e) => handleInputChange('permanent_address', 'address_line_2', e?.target?.value)}
                  />
                  
                  <Input
                    label="City"
                    type="text"
                    placeholder="Shivamoga"
                    value={formData?.permanent_address?.city}
                    onChange={(e) => handleInputChange('permanent_address', 'city', e?.target?.value)}
                  />
                  
                  <Input
                    label="Postal Code"
                    type="text"
                    placeholder="584584"
                    value={formData?.permanent_address?.postal_code}
                    onChange={(e) => handleInputChange('permanent_address', 'postal_code', e?.target?.value)}
                  />
                  
                  <Input
                    label="State"
                    type="text"
                    placeholder="Karnataka"
                    value={formData?.permanent_address?.state}
                    onChange={(e) => handleInputChange('permanent_address', 'state', e?.target?.value)}
                  />
                  
                  <Input
                    label="Country"
                    type="text"
                    placeholder="India"
                    value={formData?.permanent_address?.country}
                    onChange={(e) => handleInputChange('permanent_address', 'country', e?.target?.value)}
                  />
                </div>
              </div>
            )}

            {activeSection === 'banking' && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Banking Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Account Number"
                    type="text"
                    placeholder="1234567890123456"
                    value={formData?.banking_details?.account_number}
                    onChange={(e) => handleInputChange('banking_details', 'account_number', e?.target?.value)}
                  />
                  
                  <Input
                    label="Account Holder Name"
                    type="text"
                    placeholder="ABC Technologies Private Limited"
                    value={formData?.banking_details?.account_holder_name}
                    onChange={(e) => handleInputChange('banking_details', 'account_holder_name', e?.target?.value)}
                  />
                  
                  <Input
                    label="Bank Name"
                    type="text"
                    placeholder="HDFC Bank"
                    value={formData?.banking_details?.bank_name}
                    onChange={(e) => handleInputChange('banking_details', 'bank_name', e?.target?.value)}
                  />
                  
                  <Input
                    label="IFSC Code"
                    type="text"
                    placeholder="HDFC0001234"
                    value={formData?.banking_details?.ifsc_code}
                    onChange={(e) => handleInputChange('banking_details', 'ifsc_code', e?.target?.value)}
                  />
                  
                  <Input
                    label="Account Type"
                    type="text"
                    placeholder="Savings Account"
                    value={formData?.banking_details?.account_type}
                    onChange={(e) => handleInputChange('banking_details', 'account_type', e?.target?.value)}
                  />
                  
                  <Input
                    label="Branch Name"
                    type="text"
                    placeholder="Gurgaon Cyber City Branch"
                    value={formData?.banking_details?.branch_name}
                    onChange={(e) => handleInputChange('banking_details', 'branch_name', e?.target?.value)}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-200 bg-gray-50 flex-shrink-0">
            <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : mode === 'edit' ? 'Update Employee' : 'Create Employee'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeModal;

